export default __webpack_public_path__ + "static/media/odio_insp.6f6501ce.jpeg";